var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Input from '../../../../Forms/Input';
import styled, { x } from '@xstyled/styled-components';
import Button from '../../../../Elements/Button';
var StyledInput = styled(Input)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  z-index: ", ";\n  width: ", ";\n"], ["\n  position: ", ";\n  z-index: ", ";\n  width: ", ";\n"])), function (_a) {
    var isMobileInputView = _a.isMobileInputView;
    return (isMobileInputView ? 'absolute' : 'relative');
}, function (_a) {
    var isMobileInputView = _a.isMobileInputView;
    return (isMobileInputView ? '3' : '1');
}, function (_a) {
    var isMobileInputView = _a.isMobileInputView;
    return (isMobileInputView ? '90vw' : 'auto');
});
var QuickFilter = function (_a) {
    var searchedValue = _a.searchedValue, placeholderText = _a.placeholderText, onChange = _a.onChange, onClick = _a.onClick, displayInput = _a.displayInput, onClear = _a.onClear, isMobileInputView = _a.isMobileInputView, alwaysShowClear = _a.alwaysShowClear;
    return (_jsx(x.div, { mr: "12px", children: displayInput ? (_jsx(StyledInput, { icon: "search", type: "text", value: searchedValue, placeholder: placeholderText, onChange: onChange, variant: "gray", onClear: onClear, alwaysShowClear: alwaysShowClear, isMobileInputView: isMobileInputView })) : (_jsx(Button, { variant: "icon", appearance: "secondary", icon: "search", onClick: onClick })) }));
};
export default QuickFilter;
var templateObject_1;
